import React from 'react';
import PropTypes from 'prop-types';
import apiService from '../../../../services/api/ApiService';
import sessionReader from '../../../../store/readHelpers/SessionReader';
import buttonCss from './excelButton.scss';

class SpreadSheetInteraction extends React.Component {
    static propTypes = {
        model: PropTypes.object.isRequired,
        contentRevisionId: PropTypes.number.isRequired,
    }

    constructor(props) {
        super(props);
        this.state = {
            iframeSrc: '',
            modifiedContent: '',
        };
    }

    async componentDidMount() {
        const { model } = this.props;
        const { itemBody } = model;
        const parser = new DOMParser();
        const doc = parser.parseFromString(itemBody, 'text/html');

        this.fetchIframeSrc();
        this.parseIframe(doc);

        const interactionContainer = document.querySelector('.interaction-container');
        if (interactionContainer) {
            interactionContainer.remove(); // Remove the container from the DOM
        }
    }

    parseCustomInteraction(doc) {
        const customInteraction = doc.querySelector('custominteraction prompt');
        let promptText = null;
        if (customInteraction) {
            promptText = document.createElement('p');
            promptText.textContent = customInteraction.textContent;
            customInteraction.replaceWith(promptText);
        }

        const placeholder = document.createElement('div');
        placeholder.setAttribute('id', 'excel-button-placeholder');
        if (doc.body) doc.body.appendChild(placeholder);

        this.setState({ modifiedContent: doc.body.innerHTML });
    }

    parseIframe(doc) {
        const iframe = doc.querySelector('iframe');
        if (iframe) iframe.remove();
        this.parseCustomInteraction(doc);
    }

    async fetchIframeSrc() {
        const questionId = this.props.contentRevisionId;

        const response = await (
            (sessionReader.isContextExam() || sessionReader.isContextViewDelivery())
                ? apiService.fetchSpreadSheetIframeUrl()
                : apiService.fetchSpreadSheetIframeUrl(questionId)
        );

        const foundQuestion = this.extractIframeUrlQuestion(response, questionId);

        if (!foundQuestion || !foundQuestion.url) {
            throw Error('could not find current question iframe source');
        }

        const iframeSrc = foundQuestion.url;
        this.setState({ iframeSrc });
        this.extractFileIdAndSetLocalStorage(iframeSrc);
    }

    extractIframeUrlQuestion(response, questionId) {
        if (response.questionId) {
            return response;
        }

        return response
            .questionFileUrls
            .find(r => r.questionId === questionId);
    }

    extractFileIdAndSetLocalStorage(iframeSrc) {
        const urlObj = new URL(iframeSrc);
        const wopisrc = new URLSearchParams(urlObj.search).get('wopisrc');
        let fileId;
        if (wopisrc) {
            const parts = wopisrc.split('/');
            fileId = parts[parts.length - 1].split('?')[0]; // Extract fileID before query params
        }
        localStorage.setItem('isSpreadSheetQuestion', true);
        localStorage.setItem('studentFileId', fileId);
    }

    renderOpenInNewTabButton(url) {
        return (
            <div className={buttonCss.btnContainer}>
                <img
                    alt="excel icon"
                    src={
                        'https://res.df.onecdn.static.microsoft/officeonline/x/s' +
                        '/h35CC43103097D686__layouts/resources/FavIcon_Excel.ico'
                    }
                    className={buttonCss.excelIcon}
                />
                {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Open in Microsoft Excel for the web"
                >
                    Open in Microsoft Excel for the web
                </a>
            </div>
        );
    }

    render() {
        const { iframeSrc, modifiedContent } = this.state;
        return (
            <div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: modifiedContent,
                    }}
                />
                {iframeSrc && this.renderOpenInNewTabButton(iframeSrc)}
            </div>
        );
    }
}

export default SpreadSheetInteraction;
